<template>
    <q-dialog
        ref="dialog"
        content-class="modal-sm"
        data-vue-component="InitPortfolioDialog"
    >
        <q-card class="portfolio_dialog column q-px-lg q-py-md play-font text-white" style="background: rgba(150, 0, 255, 0.2);backdrop-filter: blur(25px);border-radius: 12px;">
            <span class="text-center text-weight-bold q-px-xl" style="font-size: 24px;line-height: 30px;margin-bottom: 28px;">Создать портфолио?</span>

            <q-space/>
            <div class="row q-gutter-xs">
                <q-btn
                    class="col"
                    style="border-radius: 12px;height: 48px;"
                    :style="!validName ? 'background: rgba(181, 197, 252, 0.2);' : 'background: linear-gradient(90deg, #9600FF 0%, #0019FF 100%);'"
                    :disable="!validName"
                    label="Да"
                    @click="onCreate"
                />
                <q-btn
                    class="col"
                    style="border-radius: 12px;height: 48px;border: 1px solid #9070D5;"
                    label="Отмена"
                    @click="$refs.dialog.hide()"
                />
            </div>
        </q-card>
    </q-dialog>
</template>

<script>
import { queryBot, queryBot2 } from 'boot/axios';
import { clearJSONValue } from 'src/pages/mockup/assistFunc.js';
import NodeDoc from 'pages/mockup/NodeDoc';
import TreeNode from 'pages/mockup/TreeNode';
import NodeBlock from 'pages/mockup/NodeBlock';

export default {
    name: 'InitPortfolioDialog',
    data () {
        return {
            checking: false,
            validName: true,
            root: new TreeNode(),
            region: '',
        };
    },
    computed: {
        state () {
            if (this.checking) {
                return 'sync';
            }
            return this.validName ? 'done' : 'close';
        },
        user () {
            return this.$store.state.pages.user || {};
        },
    },
    created () {
        this.loadRegions();
        this.loadCourse();
        const sql = 'SELECT * FROM tree_nodes WHERE type = "block"';
        return queryBot(sql)
            .then((resp) => {
                _.each(resp.data, (item) => {
                    const node = new NodeBlock();
                    node.initData(item);
                    node.initViews();
                    this.root.addNode(node);
                });
            });
    },
    methods: {
        loadCourse () {
            queryBot2('get-course-by-id', { courseId: this.user.last_course_id }).then((r) => {
                [this.course] = r.data;
                this.loading = false;
            });
        },
        loadRegions () {
            this.regions = undefined;
            queryBot(`select code, label from okato where code="${this.user.region_number}" order by label`).then((r) => {
                this.regions = r.data?.map((i) => ({
                    label: i.label,
                    value: i.code,
                }));
                this.region = _.find(this.regions, item => item.value === this.user.region_number.toString());
            });
        },
        onCreate () {
            const sql = `SELECT * FROM tree_nodes WHERE type="template" AND target=${this.user.last_course_id}`;
            queryBot(sql)
                .then((resp) => {
                    const doc = new NodeDoc();
                    this.root.addNode(doc);
                    doc.last_course_id = this.user.last_course_id;

                    doc.initData(resp.data[0]);
                    doc.type = this.user.unti_id;
                    doc.label = this.user.unti_id;
                    doc.target = -1 * resp.data[0].id;
                    doc.serverId = null;
                    doc.mockupId = 18;

                    const head = doc.findChildren('1', doc, 'serverId');
                    let field = _.find(head.fields, (f) => f.tag === 'user.shownname');
                    if (field) field.value = clearJSONValue(this.user.shownname);
                    field = _.find(head.fields, (f) => f.tag === 'course.title');
                    if (field) field.value = this.course.title;
                    field = _.find(head.fields, (f) => f.tag === 'user.about');
                    if (field) field.value = clearJSONValue(this.user.bio);
                    field = _.find(head.fields, (f) => f.tag === 'user.avatar');
                    if (field) {
                        field.value = this.user.avatar_url;
                        field.filename = this.user.avatar_url.split('/').pop();
                    }
                    field = _.find(head.fields, (f) => f.tag === 'user.region_name');
                    if (field) field.value = this.region?.label || this.user.region_name;
                    const drop = doc.findChildren('9', doc, 'serverId');
                    field = _.find(drop.fields, (f) => f.tag === 'user.mail');
                    if (field) field.value = this.user.email;
                    field = _.find(drop.fields, (f) => f.tag === 'user.tel');
                    if (field) field.value = this.user.tel;

                    doc.save()
                        .then((res) => {
                            if (res.status === 200) {
                                this.$router.push('/user/portfolio');
                                this.$emit('ok');
                                this.$refs.dialog.hide();
                            }
                        });
                });
        },
    },
};
</script>

<style scoped lang="scss">
</style>
